import React from 'react';
import { FaPhone, FaEnvelope, FaTractor, FaClock, FaHeadset, FaShieldAlt } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import './cta.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const CallToAction = () => {
    const { t } = useApp();

    // Scroll animations
    const leftRef = useScrollAnimation('fade-right');
    const rightRef = useScrollAnimation('fade-left', 0.1, 200);

    return (
        <section className="cta-section">
            <div className="cta-container">
                <div className="cta-content-wrapper">
                    {/* Left Side - Content */}
                    <div className="cta-left" ref={leftRef}>
                        <div className="cta-badge">
                            {t.cta.badge}
                        </div>

                        <h2 className="cta-title">
                            {t.cta.title}
                        </h2>

                        <p className="cta-subtitle">
                            {t.cta.subtitle}
                        </p>

                        {/* Inline Stats */}
                        <div className="cta-inline-stats">
                            <div className="inline-stat">
                                <span className="stat-number">{t.cta.stats.years}</span>
                                <span className="stat-label">{t.cta.stats.experience}</span>
                            </div>
                            <div className="stat-divider"></div>
                            <div className="inline-stat">
                                <span className="stat-number">{t.cta.stats.machines}</span>
                                <span className="stat-label">{t.cta.stats.sold}</span>
                            </div>
                            <div className="stat-divider"></div>
                            <div className="inline-stat">
                                <span className="stat-number">{t.cta.stats.customers}</span>
                                <span className="stat-label">{t.cta.stats.satisfied}</span>
                            </div>
                        </div>

                        {/* Features List */}
                        <div className="cta-features-list">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <FaClock />
                                </div>
                                <span>{t.cta.features.response}</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <FaHeadset />
                                </div>
                                <span>{t.cta.features.consultation}</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <FaShieldAlt />
                                </div>
                                <span>{t.cta.features.warranty}</span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Contact Card */}
                    <div className="cta-right" ref={rightRef}>
                        <div className="cta-contact-card">
                            <h3 className="contact-card-title">Contact Us</h3>
                            
                            <div className="contact-methods">
                                <a href="tel:0743131559" className="contact-method phone-method">
                                    <div className="method-icon">
                                        <FaPhone />
                                    </div>
                                    <div className="method-content">
                                        <span className="method-label">{t.cta.callNow}</span>
                                        <span className="method-value">0743 131 559</span>
                                    </div>
                                </a>

                                <a href="mailto:office@terasamente.com" className="contact-method email-method">
                                    <div className="method-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div className="method-content">
                                        <span className="method-label">{t.cta.sendEmail}</span>
                                        <span className="method-value">office@terasamente.com</span>
                                    </div>
                                </a>
                            </div>

                            <div className="or-divider">
                                <span>OR</span>
                            </div>

                            <a href="#inventory" className="cta-inventory-btn">
                                <FaTractor />
                                <span>{t.cta.seeInventory}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;
